export enum ModulesActionTypes {
    MODULE_LIST = '@@modules/MODULE_LIST',
    MODULE_LIST_SUCCESS = '@@modules/MODULE_LIST_SUCCESS',
    MODULE_LIST_ERROR = '@@modules/MODULE_LIST_ERROR',

    MODULE_ADD = '@@modules/MODULE_ADD',
    MODULE_ADD_SUCCESS = '@@modules/MODULE_ADD_SUCCESS',
    MODULE_ADD_ERROR = '@@modules/MODULE_ADD_ERROR',

    MODULE_UPDATE = '@@modules/MODULE_UPDATE',
    MODULE_UPDATE_SUCCESS = '@@modules/MODULE_UPDATE_SUCCESS',
    MODULE_UPDATE_ERROR = '@@modules/MODULE_UPDATE_ERROR',

    MODULE_UPDATE_STATUS = '@@modules/MODULE_UPDATE_STATUS',
    MODULE_UPDATE_STATUS_SUCCESS = '@@modules/MODULE_UPDATE_STATUS_SUCCESS',
    MODULE_UPDATE_STATUS_ERROR = '@@modules/MODULE_UPDATE_STATUS_ERROR',

    MODULE_DELETE = '@@modules/MODULE_DELETE',
    MODULE_DELETE_SUCCESS = '@@modules/MODULE_DELETE_SUCCESS',
    MODULE_DELETE_ERROR = '@@modules/MODULE_DELETE_ERROR',
}
